import { SortOrderEnum } from "../../core/dbc-gateway/generated/graphql";

let extendedComplexSearchOptions: any = document.querySelector("[data-eonext-ext-complex-search]")?.getAttribute("data-eonext-ext-complex-search") || ""
if (extendedComplexSearchOptions) {
  try {
    extendedComplexSearchOptions = JSON.parse(extendedComplexSearchOptions)
  } catch (error) {
    extendedComplexSearchOptions = {};
    console.warn("Cannot parse [data-eonext-ext-complex-search] options!", error);
  }
}

export const advancedSearchIndexes = [
  "all",
  "term.creatorcontributor",
  "term.subject",
  "term.genreandform",
  "term.mainlanguage",
  "datefirstedition",
  "term.creator",
  "term.title",
  "term.source",
  "dk5",
  "term.specificmaterialtype",
  "term.childrenoradults",
  "term.publisher",
  "term.isbn"
].concat(extendedComplexSearchOptions?.terms || []) as any;

export const advancedSearchIndexTranslations = {
  all: "advancedSearchAllIndexesText",
  "term.creatorcontributor": "advancedSearchCreatorText",
  "term.subject": "advancedSearchSubjectText",
  "term.genreandform": "advancedSearchGenreText",
  "term.mainlanguage": "advancedSearchLanguageText",
  datefirstedition: "advancedSearchDateText",
  "term.creator": "advancedSearchMainCreatorText",
  "term.title": "advancedSearchMainTitleText",
  "term.source": "advancedSearchSourceText",
  dk5: "advancedSearchDecimalDk5Text",
  "term.specificmaterialtype": "advancedSearchTypeText",
  "term.childrenoradults": "advancedSearchAudienceText",
  "term.publisher": "advancedSearchPublisherText",
  "term.isbn": "advancedSearchIdentifierText"
} as const;

export type AdvancedSearchIndex = (typeof advancedSearchIndexes)[number];

export type AdvancedSearchClause = {
  value: "AND" | "OR" | "NOT";
  translation: string;
};

export const advancedSearchClauses: AdvancedSearchClause[] = [
  { value: "AND", translation: "clauseAndText" },
  { value: "OR", translation: "clauseOrText" },
  { value: "NOT", translation: "clauseNotText" }
];

export type AdvancedSearchRowData = {
  term: string;
  searchIndex: AdvancedSearchIndex | "";
  clause: AdvancedSearchClause;
  id: number;
};

export type AdvancedSearchRowUpdateRowAspect =
  | "term"
  | "searchIndex"
  | "clause";

export type AdvancedSearchQuery = {
  rows: AdvancedSearchRowData[];
  branchId?: string;
};

export const initialAdvancedSearchQuery: AdvancedSearchQuery = {
  rows: [
    { term: "", searchIndex: "all", clause: advancedSearchClauses[0], id: 0 },
    { term: "", searchIndex: "all", clause: advancedSearchClauses[0], id: 1 }
  ]
};

export const advancedSearchFilters = {
  materialTypes: "term.generalmaterialtype",
  fiction: "term.fictionnonfiction",
  accessibility: "term.accesstype"
};

export const enum AdvancedSortMapStrings {
  Relevance = "relevance",
  TitleAsc = "sort.title.asc",
  TitleDesc = "sort.title.desc",
  CreatorAsc = "sort.creator.asc",
  CreatorDesc = "sort.creator.desc",
  LatestPubDateAsc = "sort.latestpublicationdate.asc",
  LatestPubDateDesc = "sort.latestpublicationdate.desc"
}

type AdvancedSortMapType = Record<
  AdvancedSortMapStrings,
  { index: string; order: SortOrderEnum } | undefined
>;

export const advancedSortMap: AdvancedSortMapType = {
  // AdvancedSortMapStrings.Relevance is undefined to indicate default sorting (no explicit sort parameter sent)
  [AdvancedSortMapStrings.Relevance]: undefined,
  [AdvancedSortMapStrings.TitleAsc]: {
    index: "sort.title",
    order: SortOrderEnum.Asc
  },
  [AdvancedSortMapStrings.TitleDesc]: {
    index: "sort.title",
    order: SortOrderEnum.Desc
  },
  [AdvancedSortMapStrings.CreatorAsc]: {
    index: "sort.creator",
    order: SortOrderEnum.Asc
  },
  [AdvancedSortMapStrings.CreatorDesc]: {
    index: "sort.creator",
    order: SortOrderEnum.Desc
  },
  [AdvancedSortMapStrings.LatestPubDateAsc]: {
    index: "sort.latestpublicationdate",
    order: SortOrderEnum.Asc
  },
  [AdvancedSortMapStrings.LatestPubDateDesc]: {
    index: "sort.latestpublicationdate",
    order: SortOrderEnum.Desc
  }
};

export type FirstAccessionOperatorFilter = ">" | "=" | "<";
